export const saveToLocalStorage = (user) => {
  try {
    localStorage.setItem('user', JSON.stringify(user));
  } catch (error) {
    console.error('Error saving to localStorage', error);
  }
};


export const getFromLocalStorage = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error parsing from localStorage', error);
    return null;
  }
};

export const clearFromLocalStorage = () => {
  localStorage.removeItem('user');
};
